module.exports = __webpack_public_path__ + "img/asset-tier-3.be8503cd.svg";